// initiation for chord chart
// import ref from './_state';
import fadeBtns from './update-fade-btns';
import pointSeries from './render-point-series';
import squareChartRender from './render-square-chart.js';
import updateRank from './update-rank';
import updateVcName from './update-vc-name';
// import opts from './_opts';
import chartNote from './update-footnote';
import chartTitle from './update-chart-title';
import c from './u-colours';

export default function (ref) {

    // set typeahead
    jQuery('.typeahead').typeahead('val', ref.uniNames[ref.activeIndex]);
    // run update use ref.activeIndex

    // update rank
    updateRank(ref);

    // update rank
    updateVcName(ref);

    // update square charts
    squareChartRender(ref, ref.opts.vc.squareChart);
    squareChartRender(ref, ref.opts.salary.squareChart);
    squareChartRender(ref, ref.opts.ref.squareChart);
    squareChartRender(ref, ref.opts.nss.squareChart);
    squareChartRender(ref, ref.opts.students.squareChart);

    // always start with salary
    pointSeries(ref, ref.opts.salary);
    chartNote(ref.opts.salary.footnote);
    chartTitle(ref.opts.salary.title);

    // update fade on btns
    fadeBtns(ref);

    // update square charts
    ref.dom.select('#js-square1 rect.thed3-square').style('fill', ref.opts.salary.squareChart.fColour);
    ref.dom.select('#js-square2 rect.thed3-square').style('fill', c.grey5);
    ref.dom.select('#js-square3 rect.thed3-square').style('fill', c.grey5);
    ref.dom.select('#js-square4 rect.thed3-square').style('fill', c.grey5);

    


}